import { ActionType } from 'typesafe-actions'

import { adminUsersActionType, adminUsersActions } from './actions'
import { AdminUserDetail } from './admin-users'

export interface AdminUsersState {
  readonly error: Error | null
  readonly isLoading: boolean
  readonly searchResult: AdminUserDetail | null
  readonly isUpdating: boolean
}

export const initialState: AdminUsersState = {
  error: null,
  isLoading: false,
  searchResult: null,
  isUpdating: false,
}

export const adminUsersReducer = (
  state: AdminUsersState = initialState,
  action: ActionType<typeof adminUsersActions>
) => {
  switch (action.type) {
    case adminUsersActionType.SEARCH_ADMIN_USER_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null,
      }
    case adminUsersActionType.SEARCH_ADMIN_USER_SUCCESS:
      return {
        ...state,
        searchResult: action.payload.user,
        isLoading: false,
        error: null,
      }
    case adminUsersActionType.UPDATE_ADMIN_USER_ROLE_REQUEST:
      return {
        ...state,
        isUpdating: true,
        error: null,
      }
    case adminUsersActionType.UPDATE_ADMIN_USER_ROLE_SUCCESS:
      return {
        ...state,
        searchResult: action.payload.user,
        isUpdating: false,
        error: null,
      }
    case adminUsersActionType.RESET_ADMIN_USERS:
      return initialState
    case adminUsersActionType.THROW_ERROR:
      return {
        ...state,
        isLoading: false,
        isUpdating: false,
        error: action.payload.error,
      }
    default:
      return state
  }
}